import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import ContentPageHero from '../components/ContentPageHero';
import Team from '../components/Team';
import Footer from '../components/Footer';

const TeamPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Team | PH Therapy</title>
        <meta name="description" content="Meet the PH Therapy team: Ben Duckett and Reilly Smith. AHCS-registered Clinical Exercise Physiologists serving London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/team" />
      </Helmet>
      <Header />
      <ContentPageHero
        title="Meet Our Team"
        description="Our AHCS-registered Clinical Exercise Physiologists bring expertise in MSK, cancer rehabilitation, cardiac care, and lifestyle management. Serving partners, CEOs, and professionals across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex."
        backgroundImage={`${process.env.PUBLIC_URL}/TeamImage.JPG`}
      />
      <Team />
      <Footer />
    </>
  );
};

export default TeamPage;